const fields = [
  {
    name: "clientName",
    label: "Client Name",
    data: "client",
    required: true,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "craetionDate",
    label: "Creation Date",
    data: "client",
    viewOnly: true,
  },
  {
    name: "isActive",
    label: "Client Status",
    data: "client",
    switch: true,
    validationType: "boolean",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];

export default fields;